import React, { memo } from 'react';
import { Card, Descriptions, Typography } from '../../../components';

const { Text } = Typography;

export const SourceVsphereConfiguration = memo(({ cloudAccountData }) => {
    let cloudTypes = [
        'nc2',
        'hpe_vme',
        'openshift',
        'rivermeadow_standalone',
        'azure_dr',
        'vsphere_dr',
        'vsphere_offline_replicas',
    ];
    let url;
    if (cloudTypes.includes(cloudAccountData.type)) {
        if (['nc2', 'hpe_vme', 'openshift'].includes(cloudAccountData.type)) {
            url = cloudAccountData?.appliance?.cloud_configuration?.vsphere?.url;
        } else {
            url = cloudAccountData?.appliance?.cloud_configuration?.vsphere?.source_url;
        }
    } else {
        url = cloudAccountData?.appliance?.cloud_configuration?.vsphere?.url;
    }

    return (
        <Card title="Source vSphere Configuration:" size="small">
            <Descriptions column={1} size="small">
                <Descriptions.Item label="Source vCenter URL">
                    <Text>{url}</Text>
                </Descriptions.Item>
                {cloudAccountData?.appliance?.cloud_configuration.cloud_info &&
                    cloudAccountData?.appliance?.cloud_configuration.cloud_info.source && (
                        <Descriptions.Item label="vCenter Version">
                            <Text>{cloudAccountData?.appliance?.cloud_configuration.cloud_info.source.version}</Text>
                        </Descriptions.Item>
                    )}
            </Descriptions>
        </Card>
    );
});
